
import React from 'react';
import { Checkbox } from 'antd';
import { Enviroment } from '../../../_config/constants/enviroment-v2.constant';
import { Dictionary } from './constants/style.constant';

import './styles.scss';

export default function CustomCheckbox(props) {
	const country = props.country || Enviroment.LANGUAGE;
	return (
		<>
			<Checkbox 
                {...props} className={Dictionary[country][props.className]}
            >
            </Checkbox>
		</>
	);
}